import React from 'react'
import { View, StyleSheet } from 'react-native'
import { Text } from './Themed'
import { AddMoreItemsButton } from '../screens/Checkout/Components/AddMoreItems'

const Banner = ({
	text,
	style = {},
	textStyle = {},
	showAddItemsButton = false,
	navigation = null,
}) => {
	if (text !== '') {
		return (
			<View
				style={[
					styles.container,
					{ backgroundColor: global.orgColor2 },
					style,
					showAddItemsButton && {
						flexDirection: 'row',
						justifyContent: 'space-between',
						alignItems: 'center',
					},
				]}
			>
				<Text style={[styles.bannerText, textStyle]}>{text}</Text>
				{showAddItemsButton && <AddMoreItemsButton navigation={navigation} inBanner={true} />}
			</View>
		)
	} else {
		return <></>
	}
}

const styles = StyleSheet.create({
	container: {
		width: '100%',
		alignItems: 'flex-start',
		justifyContent: 'center',
		padding: 15,
		borderRadius: 5,
		alignSelf: 'center',
	},
	bannerText: {
		color: 'white',
		fontSize: 16,
		fontWeight: 'bold',
	},
})

export default Banner
